import { createDOMIdentityCollection } from "../dsCoverage/createDOMIdentityCollection.js";
import { bitmapToCoverageCount } from "../dsCoverage/utils/bitmapToCoverageCount.js";
import { createIdentityBitmap } from "../dsCoverage/utils/createIdentityBitmap.js";
import { aggregateCoverage } from "./aggregateCoverage.js";
import { TIDAL_TELEMETRY, dsName } from "./constants.js";
import { identifyElement } from "./identifyElement.js";
import { readPathDetail } from "./readPathDetail.js";
import {
  getLicenseInfo,
  getLoggingEnabled,
  getSchedulerInterval,
  getSchedulerIntervalId,
  getUrlChangeDelay,
  getUrlChangeDelayId,
  setLicenseInfo,
  setLogging,
  setSchedulerInterval,
  setSchedulerIntervalId,
  setUrlChangeDelayId
} from "./store.js";
import { defaultGetRoot, formatCoverageCounts, skipElementChildren } from "./utils.js";
const telemetryEngine = {
  // MANUAL RUNNER
  async run(options = {}) {
    const { submitData, forceCalculation = true } = options;
    const enableLogging = getLoggingEnabled();
    const timingApi = enableLogging ? "performance" : void 0;
    const collection = await createDOMIdentityCollection({
      root: defaultGetRoot,
      dsName,
      timingApi,
      enableLogging,
      forceCalculation,
      skipElementChildren,
      getComponentIdentity: identifyElement
    });
    if (!collection) {
      return;
    }
    const pathDetail = readPathDetail();
    const licenseInfo = telemetryEngine.getLicenseInfo() ?? { product: "no-product" };
    const meta = {
      ...pathDetail,
      ...licenseInfo
    };
    const stats = telemetryEngine.aggregateCoverage(collection);
    if (submitData === "immediate") {
      try {
        await fetch("http://localhost:3000/telemetry", {
          method: "POST",
          body: JSON.stringify({
            ...meta,
            stats
          }),
          headers: { "Content-Type": "application/json" }
        });
      } catch {
      }
    } else if (submitData === "localStorage") {
    }
    return collection;
  },
  // LOCAL STORAGE
  // TODO
  writeLocalStorage: () => {
  },
  // SCHEDULING
  waitAfterUrlChange() {
    telemetryEngine.cancelWaitAfterUrlChange();
    const delay = getUrlChangeDelay();
    const id = setTimeout(() => {
      telemetryEngine.run({ submitData: "immediate" });
      telemetryEngine.startScheduler();
    }, delay);
    setUrlChangeDelayId(id);
  },
  cancelWaitAfterUrlChange() {
    clearTimeout(getUrlChangeDelayId());
  },
  startScheduler() {
    telemetryEngine.stopScheduler();
    const id = setInterval(() => {
      telemetryEngine.run({ submitData: "immediate" });
    }, getSchedulerInterval());
    setSchedulerIntervalId(id);
  },
  stopScheduler() {
    clearInterval(getSchedulerIntervalId());
    setSchedulerIntervalId();
  },
  changeSchedulerInterval(interval) {
    setSchedulerInterval(interval);
    const restart = getSchedulerIntervalId() !== void 0;
    if (restart) {
      telemetryEngine.stopScheduler();
      telemetryEngine.startScheduler();
    }
  },
  // POSTMESSAGE HELPERS
  postMessageHelpers: {
    showUI() {
      window.postMessage({
        source: TIDAL_TELEMETRY,
        action: "showUI"
      });
    },
    hideUI() {
      window.postMessage({
        source: TIDAL_TELEMETRY,
        action: "hideUI"
      });
    },
    toggleUI() {
      window.postMessage({
        source: TIDAL_TELEMETRY,
        action: "toggleUI"
      });
    }
  },
  // LOGGING
  enableLogging: () => setLogging("enabled"),
  disableLogging: () => setLogging("disabled"),
  // FORMATTING
  collectionToBitmap: createIdentityBitmap,
  collectionToCoverageMetrics(collection) {
    const bitmap = createIdentityBitmap(collection);
    const coverage = bitmapToCoverageCount(bitmap);
    return formatCoverageCounts(coverage);
  },
  aggregateCoverage,
  // METADATA
  setLicenseInfo,
  getLicenseInfo
};
export {
  telemetryEngine
};
//# sourceMappingURL=telemetryEngine.js.map
